import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "../features/filter/filterSlice";
import itemsReducer from "../features/items/itemsSlice";

export const store = configureStore({
  reducer: {
    item: itemsReducer,
    filter: filterReducer,
  },
});
